var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuestCheckIn = function SvgGuestCheckIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    clipPath: "url(#guest-check-in_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.667 8c0-2.986 0-4.479.927-5.406.928-.927 2.42-.927 5.406-.927s4.478 0 5.406.927.927 2.42.927 5.406 0 4.478-.927 5.406c-.928.927-2.42.927-5.406.927s-4.478 0-5.406-.927c-.927-.928-.927-2.42-.927-5.406Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.334 9.167s1.066.608 1.6 1.5c0 0 1.6-3.5 3.733-4.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "guest-check-in_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgGuestCheckIn;